import { createContext, useContext } from 'react';

/**
 * Whether the chat surface the reader is in is actually on screen. The floating chat keeps `ChatSurface` mounted
 * while closed (or behind the Files pane) under `visibility: hidden`, where an IntersectionObserver still sees its
 * cards — so a card's impression must also ask this. Absent = visible, for every surface that is never hidden.
 */
export const ChatSurfaceVisibleContext = createContext(true);

export const useChatSurfaceVisible = (): boolean => useContext(ChatSurfaceVisibleContext);
